import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Tooltip, Card, Modal, Tag } from "antd";
import { req_single_tqa_college } from "../../api";
import storageUtils from "../../utils/storageUtils";
import { API_BASE } from "../../utils/contrains";

import CollegeQuailtyB01 from "./college-quailty-b01";
import CollegeQuailtyB02 from "./college-quailty-b02";
import CollegeQuailtyB03 from "./college-quailty-b03";
import CollegeQuailtyB04 from "./college-quailty-b04";
import CollegeQuailtyB05 from "./college-quailty-b05";

class isShowCollegeModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    item: PropTypes.object.isRequired,
  };
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    switchStatus: true,
    domnloadFile: "",
    academicYear: this.props.item.academicYear,
    isB01Modal: false,
    isB02Modal: false,
    isB03Modal: false,
    isB04Modal: false,
    isB05Modal: false,
    isReportModal: false,
  };

  componentDidMount() {
    this.api_single_item();
  }

  api_single_item = async () => {
    const { departmentCode, academicYear } = this.props.item;
    this.setState({ loading: true });
    const result = await req_single_tqa_college(
      academicYear,
      departmentCode,
      storageUtils.getUser().token
    );
    // console.log(result);
    this.setState({ loading: false, item: result });
  };

  api_downloadfile = async (fileUrl) => {
    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "B01":
        this.setState({ isB01Modal: true, item });
        break;
      case "B02":
        this.setState({ isB02Modal: true, item });
        break;
      case "B03":
        this.setState({ isB03Modal: true, item });
        break;
      case "B04":
        this.setState({ isB04Modal: true, item });
        break;
      case "B05":
        this.setState({ isB05Modal: true, item });
        break;
      case "Report":
        this.api_downloadfile(item.WorkManualFileUrl);
        break;
      default:
    }
  };

  render() {
    const {
      isB01Modal,
      isB02Modal,
      isB03Modal,
      isB04Modal,
      isB05Modal,
      switchStatus,
    } = this.state;
    const {
      B01Status,
      B02Status,
      B03Status,
      B04Status,
      B05Status,
      WorkManualStatus,
    } = this.state.item;
    const title = (
      <>
        {this.props.item.academicYear} 學年度 {this.props.item.departmentName}{" "}
        教學評量報告
        <div style={{ float: "right" }}>
          <Tag color="red">紅色：作業提醒</Tag>|{" "}
          <Tag color="gray">灰黑色：尚未作業</Tag>|{" "}
          <Tag color="blue">藍色：部分完成</Tag>|{" "}
          <Tag color="green">綠色：全數完成</Tag>
        </div>
      </>
    );
    return (
      <Card title={title}>
        <Tooltip title="學院(中心)教育目標表">
          <button
            type="button"
            className={
              B01Status === "NONE"
                ? "btn btn-outline-dark btn-sm disabled"
                : B01Status === "DONE"
                ? "btn btn-outline-success btn-sm"
                : "btn btn-outline-primary btn-sm"
            }
            onClick={() => this.handle_show_ui_modal("B01", this.state.item)}
          >
            <i className="fa fa-align-justify"></i>
            <span style={{ marginLeft: "2px" }}>
              {switchStatus ? "學院(中心)教育目標表" : "B01"}
            </span>
          </button>
        </Tooltip>
        <Tooltip title="學院(中心)學生基本素養表">
          <button
            type="button"
            className={
              B02Status === "NONE"
                ? "btn btn-outline-dark btn-sm disabled"
                : B02Status === "DONE"
                ? "btn btn-outline-success btn-sm"
                : "btn btn-outline-primary btn-sm"
            }
            onClick={() => this.handle_show_ui_modal("B02", this.state.item)}
          >
            <i className="fa fa-align-justify"></i>
            <span style={{ marginLeft: "2px" }}>
              {switchStatus ? "學院(中心)學生基本素養表" : "B02"}
            </span>
          </button>
        </Tooltip>
        <Tooltip title="學院(中心)學生核心能力表">
          <button
            type="button"
            className={
              B03Status === "NONE"
                ? "btn btn-outline-dark btn-sm disabled"
                : B03Status === "DONE"
                ? "btn btn-outline-success btn-sm"
                : "btn btn-outline-primary btn-sm"
            }
            onClick={() => this.handle_show_ui_modal("B03", this.state.item)}
          >
            <i className="fa fa-align-justify"></i>
            <span style={{ marginLeft: "2px" }}>
              {" "}
              {switchStatus ? "學院(中心)學生核心能力表" : "B03"}
            </span>
          </button>
        </Tooltip>
        <Tooltip title="學院(中心)與校教育目標對照表">
          <button
            type="button"
            className={
              B04Status === "NONE"
                ? "btn btn-outline-dark btn-sm disabled"
                : B04Status === "DONE"
                ? "btn btn-outline-success btn-sm"
                : "btn btn-outline-primary btn-sm"
            }
            onClick={() => this.handle_show_ui_modal("B04", this.state.item)}
          >
            <i className="fa fa-align-justify"></i>
            <span style={{ marginLeft: "2px" }}>
              {" "}
              {switchStatus ? "學院(中心)與校教育目標對照表" : "B04"}
            </span>
          </button>
        </Tooltip>
        <Tooltip title="校核心能力與學院(中心)學生核心能力關聯表">
          <button
            type="button"
            className={
              B05Status === "NONE"
                ? "btn btn-outline-dark btn-sm disabled"
                : B05Status === "DONE"
                ? "btn btn-outline-success btn-sm"
                : "btn btn-outline-primary btn-sm"
            }
            onClick={() => this.handle_show_ui_modal("B05", this.state.item)}
          >
            <i className="fa fa-align-justify"></i>
            <span style={{ marginLeft: "2px" }}>
              {" "}
              {switchStatus
                ? "校核心能力與學院(中心)學生核心能力關聯表"
                : "B05"}
            </span>
          </button>
        </Tooltip>
        <Tooltip title="下載當年度報告">
          <button
            type="button"
            className={
              WorkManualStatus === "DONE"
                ? "btn btn-outline-success btn-sm"
                : "btn btn-outline-dark btn-sm disabled"
            }
            onClick={() => this.handle_show_ui_modal("Report", this.state.item)}
          >
            <i className="fa fa-align-justify"></i>
            <span style={{ marginLeft: "2px" }}>評量報告</span>
          </button>
        </Tooltip>
        <Modal
          destroyOnClose={true}
          visible={isB01Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isB01Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isB01Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CollegeQuailtyB01 department={this.state.item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isB02Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isB02Modal: false });
          }}
          onCancel={() => {
            this.setState({ isB02Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CollegeQuailtyB02 department={this.state.item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isB03Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isB03Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isB03Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CollegeQuailtyB03 department={this.state.item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isB04Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isB04Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isB04Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CollegeQuailtyB04 department={this.state.item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isB05Modal}
          width={"80%"}
          onOk={() => {
            this.setState({ isB05Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isB05Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CollegeQuailtyB05 department={this.state.item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(isShowCollegeModal);
